import {
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';
import { ModelsViewWrapperComponent } from '@app/pages/quote/standard-quote/read-only/models-view/models-view-wrapper.component';

@Component({
  selector: 'app-models-view-desktop',
  templateUrl: './models-view-desktop.component.html',
  styleUrls: ['./models-view-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModelsViewDesktopComponent extends ModelsViewWrapperComponent {
}
